import { OrganizationType } from "@remi/enums/organization-type";

export const REMI_INTERNAL_ORG = {
  id: "remi_internal",
  type: OrganizationType.REMI_INTERNAL,
  name: "Remi Internal",
} as const;

export const DEFAULT_HOMEOWNER_ORG = {
  id: "default_homeowner_org",
  name: "Homeowners",
  type: OrganizationType.HOMEOWNER,
} as const;

export const DEFAULT_SOLAR_SALES_ORG = {
  id: "default_solar_sales_org",
  name: "Solar Sales",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const DOMBOL_ORG = {
  id: "dombol",
  name: "Dombol",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const REFERRAL_ORG = {
  id: "referral",
  name: "Referral",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const REMI_WEBSITE_ORG = {
  id: "remi_website",
  name: "Remi Website",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const DEFAULT_CONTRACTOR = {
  id: "default_contractor",
  name: "Default Contractor",
  type: OrganizationType.CONTRACTOR,
} as const;

export const RLL_CONTRACTOR = {
  id: "contracting_alliance",
  name: "Remi Licensed Labor (A&F)",
  type: "CONTRACTOR",
} as const;

export const RDCL_ORG = {
  id: "radcl-1",
  name: "RDCL",
  type: OrganizationType.CONTRACTOR,
} as const;

export const ENSITE_ORG = {
  id: "ensite_services-1",
  name: "Ensite",
  type: OrganizationType.CONTRACTOR,
} as const;

export const INSPECTIFY_ORG = {
  id: "inspectify-1",
  name: "Inspectify",
  type: OrganizationType.CONTRACTOR,
} as const;

export const NOMAD_ORG = {
  id: "remi_nomad-1",
  name: "Nomad",
  type: OrganizationType.CONTRACTOR,
} as const;

export const FRONTIER_CLAIMS_ORG = {
  id: "frontier_claims-1",
  name: "Frontier Claims",
  type: OrganizationType.CONTRACTOR,
} as const;

// This is used for dealer pricing
export const DEALER_ORG = {
  id: "dealer",
  name: "Dealer",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

/* Solar Partners */

export const ARCASA_ORG = {
  id: "arcasa",
  name: "Arcasa",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const SUNRUN_ORG = {
  id: "sunrun",
  name: "Sunrun",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

/* Funding */

export const CASH_CHECK_PAYMENT_ORG = {
  id: "cash_check_payment",
  name: "Cash/Check Payment",
  type: OrganizationType.FUNDING,
} as const;

/* Vendors */

export const SRS_ORG = {
  id: "srs",
  name: "SRS Distribution",
  type: OrganizationType.VENDOR,
} as const;

export const ABC_ORG = {
  id: "abc_supply",
  name: "ABC Supply",
  type: OrganizationType.VENDOR,
} as const;

export const QXO_ORG = {
  id: "qxo",
  name: "QXO",
  type: OrganizationType.VENDOR,
} as const;

/* Insurance Partners */

export const AMERICAN_FAMILY_ORG = {
  id: "american_family",
  name: "American Family",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const BRANCH_PARTNER_ORG = {
  id: "branch",
  name: "Branch",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const WESTHILL_ORG = {
  id: "westhill",
  name: "Westhill",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const OPENLY_ORG = {
  id: "openly",
  name: "Openly",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

/* Dealers*/

export const TRUCOST_ORG = {
  id: "trucost",
  name: "TruCost",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const BREEZY_ORG = {
  id: "breezy",
  name: "Breezy",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const OPEN_DOOR_ORG = {
  id: "opendoor",
  name: "OpenDoor",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const THUMBTACK_ORG = {
  id: "thumbtack",
  name: "Thumbtack",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

export const FIELD_SALES_ORG = {
  id: "field-sales",
  name: "Field Sales",
  type: OrganizationType.SOLAR_COMPANY,
} as const;

// fakeContractor@remihq.com
export const FAKE_CONTRACTOR_ID = "user_2jIZiXrIeciBkyTlHdpHyu8ga2E";

export const CORPORATE_PARTNER_NAME_TO_ID_SANDBOX: Record<string, string> = {
  sunrun: "120",
  "1solar": "76",
  amp: "77",
  blue_raven: "78",
  bright: "79",
  elevation: "80",
  fastrac: "81",
  freedom_forever: "82",
  g3: "83",
  homeowner: "84",
  ion_solar: "85",
  kin: "86",
  lgcy: "87",
  legend: "88",
  lumio: "89",
  nusun_power: "90",
  palmetto: "91",
  rise_energy: "92",
  solare_power: "93",
  sunder_energy: "94",
  trismart_solar: "95",
  vantage_solar_power: "96",
  vitl_power: "97",
  vivint: "98",
};

// These orgs contract as ContractParty.REMI, so they resolve through this map rather than the
// RR_SOLUTIONS one. The placeholders have no counterpart in the QuickBooks sandbox company, and only
// ever have to satisfy the parent lookup: every environment that reads them mocks QuickBooks.
export const RR_CONSTRUCTION_CORPORATE_PARTNER_NAME_TO_ID_SANDBOX: Record<string, string> = {
  sunrun: "58",
  westhill: "SANDBOX-PLACEHOLDER-westhill",
  american_family: "SANDBOX-PLACEHOLDER-american-family",
  openly: "SANDBOX-PLACEHOLDER-openly",
  opendoor: "SANDBOX-PLACEHOLDER-opendoor",
  arcasa: "SANDBOX-PLACEHOLDER-arcasa",
};

export const FUNDING_PARTNER_NAME_TO_ID_SANDBOX: Record<string, string> = {
  paykeeper: "774",
  sunlight_financial: "775",
};

export const RR_CONSTRUCTION_FUNDING_PARTNER_NAME_TO_ID_SANDBOX: Record<string, string> = {
  paykeeper: "61",
  sunlight_financial: "65",
};

export const ExternalOrganizationTypes: OrganizationType[] = [
  OrganizationType.SOLAR_COMPANY,
  OrganizationType.CONTRACTOR,
  OrganizationType.VENDOR,
  OrganizationType.FUNDING,
] as const;

export const InternalBuyerIds: string[] = [
  REMI_WEBSITE_ORG.id,
  DEFAULT_CONTRACTOR.id,
  RLL_CONTRACTOR.id,
  DEFAULT_SOLAR_SALES_ORG.id,
  DOMBOL_ORG.id,
  REFERRAL_ORG.id,
  TRUCOST_ORG.id,
  BREEZY_ORG.id,
  THUMBTACK_ORG.id,
  FIELD_SALES_ORG.id,
];

// A QuickBooks customer resolves from a project's SOLAR_COMPANY and these orgs have none, so work
// billed to one of them is Remi-funded rather than owed by a partner. Deliberately narrower than
// `InternalBuyerIds`, which also covers contractors.
export const InternalSolarOrgIds: readonly string[] = [
  REMI_WEBSITE_ORG.id,
  DOMBOL_ORG.id,
  REFERRAL_ORG.id,
  FIELD_SALES_ORG.id,
];

export const MaterialSupplierVendors = [ABC_ORG, SRS_ORG, QXO_ORG] as const;

/** Close work orders over a webhook rather than in the app, and are paid outside Ramp. */
export const ExternalSiteVisitPartnerOrgIds: readonly string[] = [
  RDCL_ORG.id,
  ENSITE_ORG.id,
  INSPECTIFY_ORG.id,
] as const;

/* These will be created in the database during seeding */
export const DefaultOrganizations = [
  DEFAULT_HOMEOWNER_ORG,
  DEFAULT_SOLAR_SALES_ORG,
  REMI_WEBSITE_ORG,
  DOMBOL_ORG,
  REFERRAL_ORG,
  ABC_ORG,
  AMERICAN_FAMILY_ORG,
  OPENLY_ORG,
  DEFAULT_CONTRACTOR,
  REMI_INTERNAL_ORG,
  RLL_CONTRACTOR,
  RDCL_ORG,
  ENSITE_ORG,
  INSPECTIFY_ORG,
  SRS_ORG,
  QXO_ORG,
  BRANCH_PARTNER_ORG,
  ARCASA_ORG,
  WESTHILL_ORG,
  TRUCOST_ORG,
  BREEZY_ORG,
  THUMBTACK_ORG,
  FIELD_SALES_ORG,
] as const;
